import { render } from "./bottomCom.vue?vue&type=template&id=020147b9&scoped=true"
import script from "./bottomCom.vue?vue&type=script&lang=js"
export * from "./bottomCom.vue?vue&type=script&lang=js"

import "./bottomCom.vue?vue&type=style&index=0&id=020147b9&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020147b9"]])

export default __exports__